import React from "react";
import withIconComponent from "../withIconComponent";

var SocialFacebook = function SocialFacebook() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M9.032 23L9 13H5V9h4V6.5C9 2.789 11.298 1 14.61 1c1.585 0 2.948.118 3.345.17v3.88H15.66c-1.8 0-2.15.856-2.15 2.112V9h5.241l-2 4h-3.24v10H9.032z",
    fill: "currentColor"
  });
};

export default withIconComponent("UiSocialFacebook", false)(SocialFacebook);